import axios, {AxiosError, AxiosResponse} from 'axios';
import response_interceptor from "../interceptors/axios_response_interceptor";

const ENDPOINT = process.env.REACT_APP_ENDPOINT;
const USER = process.env.REACT_APP_AUTH_USER;
const PASSWORD = process.env.REACT_APP_AUTH_PASSWORD;

console.log("ENDPOINT:", ENDPOINT)

async function get(url: string, params?: any) {
    try {
        const instance = await getInstance();
        if (params) {
            return await instance.get(ENDPOINT + url, {params: {...params}});
        }
        return await instance.get(ENDPOINT + url);
    } catch (error) {
        throw error;
    }
}

async function post(url: string, params?: any) {
    try {
        const instance = await getInstance();

        return await instance.post(ENDPOINT + url, {...params});
    } catch (error) {
        throw error;
    }
}

async function postFormData(url: string, formData: FormData) {
    try {
        const instance = await getInstance();

        return await instance.post(ENDPOINT + url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (error) {
        throw error;
    }
}


async function put(url: string, data?: any) {
    try {
        const instance = await getInstance();
        return await instance.put(ENDPOINT + url, {...data});
    } catch (error) {
        throw error;
    }
}


async function DELETE(url: string) {
    try {
        const instance = await getInstance();
        return await instance.delete(ENDPOINT + url);
    } catch (error) {
        throw error;
    }
}

async function getInstance() {
    const api_credentials = btoa(`${USER}:${PASSWORD}`);

    let instance = axios.create({
        baseURL: ENDPOINT,
        headers: {
            'Authorization': `Basic ${api_credentials}`,
            'Content-Type': 'application/json',
        }
    });

    response_interceptor(instance);
    return instance;
}


export const API = {
    get,
    post,
    postFormData,
    put,
    DELETE,
}


export interface ApiResponseBase {
    status: string;
    status_code: number;
    message: string;
    pagination: any;
}

export interface CustomAxiosError extends AxiosError {
    response: AxiosResponse<{
        code: number;
        message: string;
    }>;
}
